/* eslint-disable */
import { ENVIRONMENT, TEST } from '../constants';
import { isFunction, isNil } from '../util/object';

export const GA_PLUGINS = ['cleanUrlTracker'];
export const GA_PROPERTY_ID = ENVIRONMENT.GA_PROPERTY_ID;

// Set variable to check on current GA enabled state
const GA_DISABLED_KEY = `ga-disable-UA-${GA_PROPERTY_ID}`;

// In worker threads, window is undefined.
// This protects against including GA in that case.
// We enable Google Analyics via the Cookie Popup
// TODO(lemieux) enable GA from embedded query param
const isGAEnabled = () => {
  if (TEST) return false;
  if (typeof window === 'undefined') return false;

  const ga = self['ga'];
  if (isNil(ga)) return false;
  if (!isFunction(ga)) return false;

  return !self[GA_DISABLED_KEY];
};

const wrappedGa = (...args) => {
  if (isGAEnabled()) {
    try {
      ga(...args);
    } catch (e) {
      // TODO(caskew): Do something with this?
    }
  }
};

export const sendEvent = (...args) => {
  wrappedGa('send', 'event', ...args);
};

export const sendTiming = (...args) => {
  wrappedGa('send', 'timing', ...args);
};

export const recordUserType = (userType) => {
  wrappedGa('set', 'dimension1', userType);
};

let gaServerId = undefined;
export const recordServerId = (serverId) => {
  if (gaServerId || !serverId) return;

  wrappedGa('set', 'dimension2', serverId);
  gaServerId = serverId;
};

export const recordDefaultCreativeMode = (creativeMode) => {
  wrappedGa('set', 'dimension3', creativeMode);
};

export default wrappedGa;
